import React from 'react'

import './loader.css'
const Loader = () => {
  return (
    <div className='container-loader'>
      <span className='loader'></span>
    </div>
  )
}

export default Loader
